module.exports = {"340521100":"姑孰镇","340521101":"黄池镇","340521102":"乌溪镇","340521103":"石桥镇","340521104":"塘南镇","340521105":"护河镇","340521106":"太白镇","340521110":"年陡镇","340521111":"湖阳镇","340521200":"大陇乡","340521202":"江心乡","340521400":"当涂经济开发区","340521401":"当涂青山河高新技术产业园区","340521402":"当涂大青山李白文化旅游区","340521500":"当涂现代农业示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340521.json
// module id = 989
// module chunks = 0